'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles.js');

var Styles = _interopRequireWildcard(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoBox = function InfoBox(_ref) {
    var marker = _ref.marker,
        travelMode = _ref.travelMode,
        travelModes = _ref.travelModes,
        getAllDirections = _ref.getAllDirections,
        getDrivingDirections = _ref.getDrivingDirections,
        getWalkingDirections = _ref.getWalkingDirections,
        getBicyclingDirections = _ref.getBicyclingDirections,
        clearDirections = _ref.clearDirections,
        stylesheetDirectory = _ref.stylesheetDirectory,
        directions = _ref.directions,
        drivingDirections = _ref.drivingDirections,
        bicyclingDirections = _ref.bicyclingDirections,
        walkingDirections = _ref.walkingDirections,
        infoBoxIsOpen = _ref.infoBoxIsOpen,
        infoBoxIsClickable = _ref.infoBoxIsClickable;

    if (!directions || !drivingDirections || !bicyclingDirections || !walkingDirections) {
        return _react2.default.createElement(
            Styles.InfoBox,
            { isOpen: infoBoxIsOpen },
            _react2.default.createElement('span', { onClick: function onClick() {
                    return clearDirections();
                }, className: 'close' }),
            _react2.default.createElement(
                'h4',
                null,
                'Loading...'
            )
        );
    }

    var drivingDirectionsIsActive = false;
    var bicyclingDirectionsIsActive = false;
    var walkingDirectionsIsActive = false;

    switch (travelMode) {
        case 'DRIVING':
            drivingDirectionsIsActive = true;
            break;
        case 'BICYCLING':
            bicyclingDirectionsIsActive = true;
            break;
        case 'WALKING':
            walkingDirectionsIsActive = true;
            break;
    }

    return _react2.default.createElement(
        Styles.InfoBox,
        { isOpen: infoBoxIsOpen },
        _react2.default.createElement('h4', { className: 'infobox-title', dangerouslySetInnerHTML: { __html: '' + marker.title } }),
        _react2.default.createElement('p', { className: 'infobox-address', dangerouslySetInnerHTML: { __html: marker.address } }),
        _react2.default.createElement('span', { onClick: function onClick() {
                return clearDirections();
            }, className: 'close' }),
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                Styles.InfoBoxRoute,
                {
                    isClickable: infoBoxIsClickable,
                    isActive: drivingDirectionsIsActive,
                    stylesheetDirectory: stylesheetDirectory,
                    onClick: function onClick() {
                        return getDrivingDirections(marker, 'DRIVING');
                    },
                    firstChild: true
                },
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-header' },
                    _react2.default.createElement('div', { className: 'infobox-route-radio' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-body' },
                    _react2.default.createElement('div', { className: 'icon icon--driving' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'icon__text' },
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Distance: ' + drivingDirections.routes[0].legs[0].distance.text
                            }
                        }),
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Time: ' + drivingDirections.routes[0].legs[0].duration.text
                            }
                        })
                    )
                )
            ),
            _react2.default.createElement(
                Styles.InfoBoxRoute,
                {
                    isClickable: infoBoxIsClickable,
                    isActive: bicyclingDirectionsIsActive,
                    stylesheetDirectory: stylesheetDirectory,
                    onClick: function onClick() {
                        return getBicyclingDirections(marker, 'BICYCLING');
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-header' },
                    _react2.default.createElement('div', { className: 'infobox-route-radio' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-body' },
                    _react2.default.createElement('div', { className: 'icon icon--bicycling' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'icon__text' },
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Distance: ' + bicyclingDirections.routes[0].legs[0].distance.text
                            }
                        }),
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Time: ' + bicyclingDirections.routes[0].legs[0].duration.text
                            }
                        })
                    )
                )
            ),
            _react2.default.createElement(
                Styles.InfoBoxRoute,
                {
                    isClickable: infoBoxIsClickable,
                    isActive: walkingDirectionsIsActive,
                    stylesheetDirectory: stylesheetDirectory,
                    onClick: function onClick() {
                        return getWalkingDirections(marker, 'WALKING');
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-header' },
                    _react2.default.createElement('div', { className: 'infobox-route-radio' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'infobox-route-body' },
                    _react2.default.createElement('div', { className: 'icon icon--walking' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'icon__text' },
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Distance: ' + walkingDirections.routes[0].legs[0].distance.text
                            }
                        }),
                        _react2.default.createElement('span', {
                            dangerouslySetInnerHTML: {
                                __html: 'Time: ' + walkingDirections.routes[0].legs[0].duration.text
                            }
                        })
                    )
                )
            )
        )
    );
};

InfoBox.propTypes = {
    marker: _propTypes2.default.object,
    travelMode: _propTypes2.default.string,
    travelModes: _propTypes2.default.array,
    getAllDirections: _propTypes2.default.func,
    getDrivingDirections: _propTypes2.default.func,
    getWalkingDirections: _propTypes2.default.func,
    getBicyclingDirections: _propTypes2.default.func,
    clearDirections: _propTypes2.default.func,
    stylesheetDirectory: _propTypes2.default.string,
    directions: _propTypes2.default.object,
    drivingDirections: _propTypes2.default.object,
    bicyclingDirections: _propTypes2.default.object,
    walkingDirections: _propTypes2.default.object,
    infoBoxIsOpen: _propTypes2.default.bool,
    infoBoxIsClickable: _propTypes2.default.bool
};

exports.default = InfoBox;


// WEBPACK FOOTER //
// ./scripts/react/storelocator/InfoBox.js